export const ageMethod = "age nearest";
export const gateway = "https://qat-scoop-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/scoop";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzY29vcCIsIm5hbWUiOiJzY29vcCIsImlhdCI6MTc4MDU4MzcxNCwiZXhwIjoxOTM4MzcxNzE0fQ.ee93M2b1_qfsXTOC0pVDH2xcbeSJR2NaiehMVOkkFkk";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-scoop-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_scoop",
			brands: [
				"qat-scoop-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "scoop",
			broker_formatted_name: "Scoop Financial",
			email: "customercare@scoopfinancial.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-888-922-8422",
			photos: [
				"photo1.png",
			],
			privacyLink: "https://scoopfinancial.ca/privacy/",
			website: "https://scoopfinancial.ca/",
			scope: "scoop#branding#qat-scoop-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-scoop-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_scoop",
			brands: [
				"qat-scoop-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "scoop",
			broker_formatted_name: "Scoop Financial",
			email: "customercare@scoopfinancial.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-888-922-8422",
			photos: [
				"photo1.png",
			],
			privacyLink: "https://scoopfinancial.ca/privacy/",
			website: "https://scoopfinancial.ca/",
			scope: "scoop#branding#qat-scoop-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-scoop-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:35:14 GMT+0000 (Coordinated Universal Time)
